import styled from 'styled-components';

const MeasureInfoWrap = styled.div`
  align-items: center;
  display: inline-flex;
  flex-direction: row;
  margin: 0 0 0 1.275rem;
  width: 100%;

  svg {
    margin-left: 4px;
  }
`;

export default {
  MeasureInfoWrap,
};
